/* eslint-disable max-len */
import { ProviderCheckboxes } from './types';
import { COMPLIANCE_CHECKLIST_ITEMS } from '../utils/complianceChecklistCopy';

export const Checkboxes: ProviderCheckboxes[] = COMPLIANCE_CHECKLIST_ITEMS.map((label, index) => ({
  value: `checkbox${index + 1}`,
  label,
  isSelected: false,
}));

export const consultationFormDefaultValues = {
  isAdditionalPeople: false,
  additionalPeople: '',
  checkboxes: Checkboxes,
  verifyingInformation: false,
  selectedImages: [],
  cdt: [],
  is_terms_accepted: false,
  assessment: '',
  subjective: {
    chief_complaint_problem: '',
    pain_scale: '',
    medical_history: '',
  },
  plan: {
    disposition: '',
    prescription_in_icore: '',
    pharmacy: '',
    need_for_oral_health_coaching: '',
  },
  objective: {
    is_media_utilized: '',
    is_intra_oral_utilized: '',
    is_extra_oral_utilized: '',
  },
  treatments: [],
  prescriptions: [],
  followUp: {
    care_coordination: false,
    oral_health_coaching: false,

    care_coordination_type: '',
    care_coordination_urgency: '',
    care_coordination_reason: '',

    oral_health_coaching_type: '',
    oral_health_coaching_urgency: '',
    oral_health_coaching_reason: '',
  },
  educations: [],
  careCoordinationFindings: {
    benefits: '',
    scheduled_dental_appointment: '',
  },
  caseNotes: '',
  additionalCondition: [
    {
      label: '',
      value: '',
    },
  ],
  additionalInfo: [
    {
      label: '',
      value: '',
    },
  ],
  pharmacies: {
    pharmacy_name: '',
    pharmacy_street_address: '',
    pharmacy_city: '',
    pharmacy_state: '',
    pharmacy_zip_code: '',
    pharmacy_phone_number: '',
  },
  oralHealthCoachingInternalNote: '',
  care_plan: {
    consultation_summary: '',
    goals: [
      {
        id: 0,
        goal_text: '',
        educations: [],
      },
    ],
  },
  pharmacy_name: '',
  pharmacy_street_address: '',
  pharmacy_city: '',
  pharmacy_state: '',
  pharmacy_zip_code: '',
  pharmacy_phone_number: '',
};

export const editImageNoteDefaultValues = {
  isOpen: false,
  media_id: '',
  media_src: '',
  oneReportId: '',
  readOnly: false,
};

export const removeImageDefaultValues = {
  isOpen: false,
  media_id: '',
  media_src: '',
  oneReportId: '',
};

export const removeAttachmentDefaultValues = {
  isOpen: false,
  media_id: '',
  media_name: '',
  oneReportId: '',
};

export const unassignProviderModalDefaultValues = {
  isOpen: false,
  caseId: 0,
  providerName: '',
};
